import mitt from 'mitt'

// Define event types for type safety
type Events = {
  // UI events
  'helpVisible': boolean
  'updateVisible': boolean
  'loading-token': boolean

  // Filter events
  'task-filter-changed': unknown
  'protocol-filter-changed': unknown
  'contact-filter-changed': unknown

  // Data update events
  'task-updated': unknown
  'protocol-updated': unknown
  'contact-updated': unknown
  'user-updated': unknown

  // Modal events
  'open-modal': { name: string; props?: Record<string, unknown> }
  'close-modal': string

  // Generic events (for backwards compatibility)
  [key: string]: unknown
}

const emitter = mitt<Events>()

// Export both the emitter and a backwards-compatible default export
export const EventBus = {
  $on: emitter.on.bind(emitter),
  $off: emitter.off.bind(emitter),
  $emit: emitter.emit.bind(emitter),
  // For direct access to mitt methods
  on: emitter.on.bind(emitter),
  off: emitter.off.bind(emitter),
  emit: emitter.emit.bind(emitter),
  all: emitter.all
}

export default EventBus
